import { Component, OnInit } from '@angular/core';
import { TokenService } from 'src/app/services/common/token.service';
import { SdoService } from 'src/app/services/sdo.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';


@Component({
  selector: 'app-xen',
  templateUrl: './xen.component.html',
  styleUrls: ['./xen.component.scss']
})
export class XenComponent implements OnInit {

  public Data: any;
  autoId: any;
  application: any;
  constructor(private tokenService: TokenService,private messageService: MessageService,
    private sdoService: SdoService, private router: Router,private cryptoJsService: CryptoJsService,private loader: AppLoaderService) { }


  ngOnInit(): void {
    this.loadData();
  }
  loadData() {
    this.loader.start();
    this.sdoService
      .getAppForPhysicalVerMIDone(this.autoId)
      .pipe()
      .subscribe({
        next: (data) => {
          this.Data = data;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Dashboard not loaded.',
          });
        },
      });
  }
  selectviewform(form: any) {
    if (form.AutoId) {
      let encryptedAutoId = this.cryptoJsService.Encrypt(form.AutoId.toString());
      this.router.navigate(['sdo', 'view-form'], { queryParams: { autoId: encryptedAutoId } });
    }else{
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
    }

  }


}
